import { Auth } from 'aws-amplify';

const logout = () => {
  return Auth.signOut();
};

export default logout;
